import RequestForm from './RequestForm.vue';

export * from './types';
export default RequestForm;



// WEBPACK FOOTER //
// ./src/components/parts/catalog/card/components/request/components/requestform/index.ts